// src/components/About/HobbiesSection.jsx
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './HobbiesSection.css';

export default function HobbiesSection() {
  const hobbies = [
    {
      id: 'hiking',
      title: 'Hiking',
      //image: '/images/hiking.jpg',
      details:
        'I love exploring trails near Seattle. My favorite hike is Mount Teneriffe',
    },
    {
      id: 'automation',
      title: 'Home Automation Projects',
      //image: '/images/home-automation.jpg',
      details:
        'I build IoT solutions with Raspberry Pi and Home Assistant to automate my home.',
    },
    {
      id: 'guitar',
      title: 'Playing Guitar',
      //image: '/images/guitar.jpg',
      details:
        'I practice guitar daily. I love to practice new techniques and styles',
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <section className="hobbies-section">
      <h2>How I Spend My Time</h2>
      <div className="hobbies-slider-container">
        <Slider {...settings}>
          {hobbies.map((hobby) => (
            <div key={hobby.id} className="hobby-slide">
              <div className="hobby-card">
                <h3 className="hobby-title">{hobby.title}</h3>
                {hobby.image && <img
                  src={hobby.image}
                  alt={hobby.title}
                  className="hobby-image"
                />}
                <p className="hobby-details">{hobby.details}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}